import { render, staticRenderFns } from "./PasoDos.vue?vue&type=template&id=643a53d1"
import script from "./PasoDos.vue?vue&type=script&lang=js"
export * from "./PasoDos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports